import { update, ColorSchemePatchBody } from 'redux/api/Admin/Customization'

import { Dispatch } from 'redux'
import { toggleSnackbarOpen } from 'redux/actions/Snackbar'
import { SnackbarMessage } from 'types/GlobalSnackbar'
import { useThunkActions } from 'redux/actions/useThunkActions'

import * as actions from './actions'

function tryUpdateColorScheme(body: ColorSchemePatchBody) {
  return (dispatch: Dispatch) => {
    dispatch(actions.update())

    update(body)
      .then((response) => {
        dispatch(actions.updateSuccess(response.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.SettingsSaved))
      })
      .catch(() => {
        dispatch(actions.updateFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.SettingsSavedFailed))
      })
  }
}

export const useCustomizationActions = () => {
  return {
    tryUpdateColorScheme: useThunkActions(tryUpdateColorScheme)
  }
}
